export enum AuditFormControlTypeEnum {
  FREETEXT = 'FREETEXT',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO'
}
